const getStatusString = (theapp, status) => {
	switch(status) {
		case 10:
			return theapp.t('success');
		case 5:
			return theapp.t('pending');
		case -5:
			return theapp.t('not found');
		case -10:
			return theapp.t('fail');
		default:
			return theapp.t('unknown');
	} 
}

export default getStatusString;